import { FC, useState, useEffect } from "react";

import styles from "../headerBtn.module.scss";
import clsx from "clsx";

interface IDownloadOptions {
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setSelectedFiles: (el: string[] | File[]) => void;
  selectedFiles: File[];
  setIsDisabled: (el: boolean) => void;
}

const OutletsDownloadSection: FC<IDownloadOptions> = ({
  handleFileChange,
  setSelectedFiles,
  selectedFiles,
  setIsDisabled,
}) => {
  const [uploadProgress, setUploadProgress] = useState<any[]>([]);

  const handleClickCancel = (index: number) => {
    setSelectedFiles([
      ...selectedFiles.slice(0, index),
      ...selectedFiles.slice(index + 1)
    ]);
    const newUploadProgress = uploadProgress;
    delete uploadProgress[selectedFiles.length - 1];
    setUploadProgress(newUploadProgress);
  };

  useEffect(() => {
    const lastIndex = selectedFiles.length - 1;

    if (!uploadProgress.hasOwnProperty(lastIndex)) {
      const uploadRequests: any = [];

      const simulateFileUpload = (file: File, index: number) => {
        const totalSize = file.size;
        let loaded = 0;
        const chunkSize = 1024;

        const totalDuration = 300;
        const totalChunks = Math.ceil(totalSize / chunkSize);
        const intervalDuration = totalDuration / totalChunks;

        const uploadInterval = setInterval(() => {
          if (loaded < totalSize) {
            setIsDisabled(true);
            loaded += Math.min(chunkSize, totalSize - loaded);
            const progressPercentage = (loaded / totalSize) * 100;

            setUploadProgress((prev) => ({
              ...prev,
              [index]: progressPercentage,
            }));
          } else {
            clearInterval(uploadInterval);
            setUploadProgress((prev) => ({
              ...prev,
              [index]: 100,
            }));
            setIsDisabled(false);
          }
        }, intervalDuration);

        uploadRequests.push({ clear: () => clearInterval(uploadInterval) });
      };

      const lastFile = selectedFiles[lastIndex];
      if (lastFile) {
        simulateFileUpload(lastFile, lastIndex);
      }

      return () => {
        uploadRequests.forEach((request: any) => {
          request.clear();
        });
      };
    }
    // eslint-disable-next-line
  }, [selectedFiles]);

  return (
    <div className={styles.download__outlets_block}>
      <div className={styles.download__outlets_rowBlock}>
        <span className={styles.block__info_title}>Загрузите Excel файл:</span>
        <input
          accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          className="download__file_input"
          onChange={handleFileChange}
          placeholder="Загрузить"
          type="file"
          name="file"
          id="file"
        />
        <label htmlFor="file" className="file__label">
          Загрузить
        </label>
      </div>
      <div className={styles.file__list}>
        {selectedFiles.map((file: File, index: number) => {
          const fileSize = (file.size / (1024 * 1024)).toFixed(2);
          const progress = uploadProgress[index] || 0;

          return (
            <div key={index} className={clsx(styles.file__list_elem, styles.file__list_elem__full)}>
              <div className={styles.file__list_dot}></div>
              <span className={styles.file__name}>{file.name}</span>
              <span>
                {progress.toFixed(0)}% от {fileSize} MB
              </span>
              <span
                className={styles.cancel__file_btn}
                onClick={() => handleClickCancel(index)}
              >
                Отменить
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OutletsDownloadSection;
